module.exports = __webpack_public_path__ + "static/img/icon14.8628942.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon14.png
// module id = +pVS
// module chunks = 1